import React from "react";
import ReactDOM from "react-dom";
import App from "components/App";
import "./index.css";

global.React = React;
ReactDOM.render(<App />, document.getElementById("app"));
